import React, { useEffect, useState } from "react"
import { Card, Divider, Form } from "semantic-ui-react"
import api from "../../api"
import CheckboxWithLabelForForm from "../ui/CheckboxWithLabelForForm"
import { set } from "lodash"
import { PasswordInput } from "../ui/Admin/Form/PasswordInput"
import api2 from "~/api2"

interface componentProps {
  campSlug: string
  setErrorMessage: (arg: string) => void
  token?: string
}

const SignupForm = (props: componentProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const [password, setPassword] = useState("")
  const [passwordConfirmation, setPasswordConfirmation] = useState("")
  const [isCheckedTerms, setIsCheckedTerms] = useState(false)

  const handlePasswordChange = (e, { value }) => {
    setPassword(value)
  }

  const passwordIsValid = () => {
    const regexp = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/
    return regexp.test(password)
  }

  const handlePasswordConfirmationChange = (e, { value }) => {
    setPasswordConfirmation(value)
  }

  const passwordsMatch = () => {
    return password == passwordConfirmation
  }

  const handleSubmit = () => {
    if (!isCheckedTerms) {
      props.setErrorMessage("You must accept the terms of service and privacy policy.")
      return
    }

    setIsLoading(true)

    api2.Reservations
      .adminSignupConfirmation(password, passwordConfirmation, props.token)
      .then(() => {
        window.location.href = `${window.origin}/admin/login`
        props.setErrorMessage("")
      })
      .catch((errResponse: any) => {
        let errors = []

        for (let key in errResponse) {
          errors.push([key, errResponse[key]].join(" "))
        }

        props.setErrorMessage(errors.join(", "))
        setIsLoading(false)
      })
    
  }

  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>{"Accept invitation"}</Card.Header>
        <Card.Meta>{"Set a password for your account. You will be logged in after setting your password."}</Card.Meta>

        <Divider />

        <Form onSubmit={handleSubmit} loading={isLoading}>
          <PasswordInput
            icon={
              password.length > 0 && passwordIsValid()
                ? {
                    name: "check circle",
                    color: "green",
                  }
                : {
                    name: "key",
                  }
            }
            label="Password"
            onChange={handlePasswordChange}
            value={password}
            placeholder={"Password"}
            required
          />

          <PasswordInput
            label="Password Confirmation"
            required
            icon={
              passwordConfirmation.length > 0 && passwordsMatch()
                ? {
                    name: "check circle",
                    color: "green",
                  }
                : {
                    name: "key",
                  }
            }
            value={passwordConfirmation}
            placeholder={"Retype password"}
            onChange={handlePasswordConfirmationChange}
          />

          <div className="my-8">
            <CheckboxWithLabelForForm
              label={
                <span>
                  I acknowledge that I have reviewed and accept our{" "}
                  <a
                    className="underline text-blue-500"
                    href="https://www.poweredbypark.com/terms-and-conditions"
                    target="_blank"
                  >
                    Terms of Service
                  </a>{" "}
                  and consent to the storing and processing of your personal data as described in our{" "}
                  <a
                    className="underline text-blue-500"
                    href="https://www.poweredbypark.com/privacy-policy"
                    target="_blank"
                  >
                    Privacy Policy
                  </a>
                  .
                </span>
              }
              value={isCheckedTerms}
              setValue={() => setIsCheckedTerms(!isCheckedTerms)}
            />
          </div>

          <Form.Button
            fluid
            primary
            disabled={!(password && passwordConfirmation && password === passwordConfirmation)}
          >
            {"Set password"}
          </Form.Button>
        </Form>
      </Card.Content>
    </Card>
  )
}

export default SignupForm
